import React, {Component} from "react";
import LoginForm from "../componentsBody/LoginForm.js";

class ModalLogin extends Component {
    render() {
        return (
            <div className="modal fade" id="modalLogin" tabIndex="-1" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title">Login</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <p className="login-modal-message"></p>
                            <LoginForm isModal={true}/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default ModalLogin;


// WEBPACK FOOTER //
// ./src/componentsHeader/ModalLogin.js